import { Request } from '../../classes/Request';

/**********************************************************SAVE AVATAR************************************************************************/
// The catalog is served by core's 'token' middleware, which only accepts the shared token as a Bearer header.
export const getOptionsByUrl = async (url, dependentValues, urlValues) => {
  let urlParams = urlValues.substring(0, urlValues.length - 1);
  const request = new Request(`${url}?${urlParams}`, 'get', null, {
    dependentValues,
  });
  const getOptionsByUrlData = await request.executeRequest(
    true,
    `Bearer ${process.env.REACT_APP_TOKEN}`
  );
  if (getOptionsByUrlData) {
    return getOptionsByUrlData;
    //SHOW A SUCCESS ALERT WITH THE MESSAGE RETURNED BY THE API
  } else {
    console.log(getOptionsByUrlData);
  }
};
/***********************************************************************************************************************************************/
